export const AwsConfigAuth = {
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_MTgdQ9p5i',
    userPoolWebClientId: '2jk6mkc4gc3o8269c54al9atoc',
    authenticationFlowType: "USER_SRP_AUTH",
};